import { IoChevronDown, IoChevronForward, IoDocumentTextOutline } from 'react-icons/io5';
import ReportEditPanel from './ReportEditPanel';
import './reports.css';

/**
 * One chapter read. Tapping it opens the edit panel; in select mode the whole
 * row toggles its checkbox instead.
 */
const ReportRow = ({
  report,
  showReader,
  selectMode,
  selected,
  onToggleSelect,
  editing,
  editActions,
  nested = false
}) => {
  const isEditing = editing?.id === report.id;
  const reference = `${report.chapter?.book ?? 'Chapter'} ${report.chapter?.chapter ?? ''}`.trim();

  const content = (
    <>
      <span className="report-ref">{reference}</span>
      {showReader && report.reader?.name && <span className="report-reader">{report.reader.name}</span>}
      {report.notes && (
        <IoDocumentTextOutline className="report-note-icon" aria-label="Has notes" />
      )}
    </>
  );

  return (
    <li className={`report-row ${nested ? 'report-row--nested' : ''} ${selected ? 'is-selected' : ''}`}>
      {selectMode ? (
        <label className="report-row-main">
          <input
            type="checkbox"
            checked={selected}
            onChange={() => onToggleSelect(report.id)}
          />
          {content}
        </label>
      ) : (
        <button
          type="button"
          className="report-row-main"
          aria-expanded={isEditing}
          onClick={() => (isEditing ? editActions.cancel() : editActions.start(report))}
        >
          {content}
          {isEditing ? <IoChevronDown aria-hidden="true" /> : <IoChevronForward aria-hidden="true" />}
        </button>
      )}

      {isEditing && !selectMode && (
        <ReportEditPanel
          report={report}
          editing={editing}
          onChange={editActions.change}
          onSave={editActions.save}
          onCancel={editActions.cancel}
          onDelete={editActions.remove}
        />
      )}
    </li>
  );
};

export default ReportRow;
